import { formatTime } from "../../utilities/time";

interface TimelineTooltipProps {
  startTime: number;
  endTime: number;
  text: string;
}

export function TimelineTooltip({
  startTime,
  endTime,
  text
}: TimelineTooltipProps) {
  return (
    <div className="tw-absolute tw-bottom-full tw-mb-2 tw-left-1/2 -tw-translate-x-1/2 tw-bg-black/90 tw-text-white tw-rounded-lg tw-p-3 tw-text-sm tw-min-w-[200px] tw-shadow-xl tw-backdrop-blur-sm">
      <div className="tw-font-medium tw-mb-1">{text}</div>
      <div className="tw-text-white/70 tw-text-xs tw-mb-2">
        {formatTime(startTime)} - {formatTime(endTime)}
      </div>
      <div className="tw-absolute -tw-bottom-1 tw-left-1/2 -tw-translate-x-1/2 tw-w-2 tw-h-2 tw-bg-black/90 tw-rotate-45" />
    </div>
  );
}